import { computed, reactive, nextTick } from 'vue';
import { uuid } from 'vue-uuid';
export default {
  components: {},
  props: {
    isCheck: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {emit}) {//emit 傳到複層_emit('update:{function}', val)
    const {isCheck} = props;

    const state = reactive({
      id: uuid.v4(),

    })

    const privateIsChecked = computed({
      get: () => isCheck,
      set: (val) => {
        emit('update:isCheck', val);
      }
    })

    const   onClickKeypress = () => {
      nextTick(()=>{
        document.getElementById(state.id).click()
      })
    }

    return {
      privateIsChecked,
      state,
      onClickKeypress
    }
  }
}


